export default {"src":"/_next/static/media/boom_24.ccf9dbd5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};